<script setup lang="ts">
const props = defineProps({
	color: {
		type: String,
		default: '',
	},
	width: {
		type: String,
		default: '24',
	},
	height: {
		type: String,
		default: '24',
	},
	strokeWidth: {
		type: String,
		default: '2',
	},
});
const color = computed(() => props.color);
const { color: iconColor } = useIconColor(color);
</script>
<template>
	<svg
		xmlns="http://www.w3.org/2000/svg"
		:width="width"
		:height="height"
		viewBox="0 0 20 20"
		fill="none"
	>
		<g clip-path="url(#clip0_7932_79366)">
			<path
				d="M9.99935 13.3333V9.99999M9.99935 6.66666H10.0077M18.3327 9.99999C18.3327 14.6024 14.6017 18.3333 9.99935 18.3333C5.39698 18.3333 1.66602 14.6024 1.66602 9.99999C1.66602 5.39762 5.39698 1.66666 9.99935 1.66666C14.6017 1.66666 18.3327 5.39762 18.3327 9.99999Z"
				:stroke="iconColor"
				:stroke-width="strokeWidth"
				stroke-linecap="round"
				stroke-linejoin="round"
			/>
		</g>
		<defs>
			<clipPath id="clip0_7932_79366">
				<rect
					width="20"
					height="20"
					fill="white"
				/>
			</clipPath>
		</defs>
	</svg>
</template>
